export default "__VITE_ASSET__DV7XPVdF__"